import { render, staticRenderFns } from "./DeleteReasons.vue?vue&type=template&id=43b57934&"
import script from "./DeleteReasons.vue?vue&type=script&lang=js&"
export * from "./DeleteReasons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports